import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { apiErr } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Lock } from "lucide-react";

export const AdminLogin = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F8F7] px-4">
      <form onSubmit={submit} data-testid="admin-login-form"
        className="w-full max-w-md bg-white rounded-3xl border border-[#DDE5E2] shadow-sm p-8">
        <div className="flex items-center gap-2 text-[#6C8EAD] mb-1">
          <Lock className="h-5 w-5" />
          <span className="text-xs uppercase tracking-[0.15em] font-semibold">Area riservata</span>
        </div>
        <h1 className="text-2xl font-semibold text-[#2B3A42]">Studio Scala Milano</h1>
        <p className="text-sm text-[#5B6E78] mt-1 mb-6">Accedi per gestire le simulazioni.</p>

        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-sm">Email</Label>
            <Input data-testid="admin-email-input" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} className="h-11 border-[#DDE5E2]" required />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm">Password</Label>
            <Input data-testid="admin-password-input" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} className="h-11 border-[#DDE5E2]" required />
          </div>
        </div>

        {error && <p data-testid="admin-login-error" className="text-sm text-[#9E4756] mt-4">{error}</p>}

        <Button data-testid="admin-login-submit" type="submit" disabled={loading}
          className="w-full mt-6 h-11 rounded-full bg-[#6C8EAD] hover:bg-[#4F708C] text-white">
          {loading ? "Accesso..." : "Accedi"}
        </Button>
      </form>
    </div>
  );
};
